import { RootState } from 'store';

import { useSelector } from 'react-redux';

import {
  checkIsLoading,
  checkIsLoadingDone
} from 'common/utils/checkLoading';

import { STATIONS_STATE } from '../../constants';

export const useStationsPriceReportTimeSlotsLoadingStatus = () => useSelector(
  (state: RootState) => state[STATIONS_STATE].stationsPricesReportTimeSlots.loadingStatus
);

export const useIsStationsPriceReporTimeSlotsLoading = () => {
  const stationsPriceReportTimeSlotsLoadingStatus = useStationsPriceReportTimeSlotsLoadingStatus();
  return checkIsLoading(stationsPriceReportTimeSlotsLoadingStatus);
};

export const useIsStationsPriceReporTimeSlotsDone = () => {
  const stationsPriceReportTimeSlotsLoadingStatus = useStationsPriceReportTimeSlotsLoadingStatus();
  return checkIsLoadingDone(stationsPriceReportTimeSlotsLoadingStatus);
};

export const useStationsPriceReportTimeSlots = () => (
  useSelector((state: RootState) => state[STATIONS_STATE].stationsPricesReportTimeSlots.data)
);
